import styled from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';
import {
  ACTIVE_ASSAILANT,
  TRAIN_INCIDENT_ALERT_TYPE,
} from '@rsos/constants/alertTypes';
import { BP_LAPTOP } from '@rsos/constants/breakpoints';
import {
  AGENCY_CHAT,
  ALERTS,
  EMERGENCY_CALLS,
} from '@rsos/constants/incidentTypes';
import {
  QUEUE_FIXED_WIDTH,
  QUEUE_FULL_WIDTH,
} from '@rsos/constants/queueWidths';

const TITLE_WRAPPER_HEIGHT = 48;
const TABS_HEIGHT = 36;
const CONNECTED_UNIVERSAL_SEARCH_HEIGHT = 70;
const ALL_EVENTS_CONTAINER_HEIGHT_EXTENDED = 78; // view Jurisdiction container belows tabs extended for new UI

export const Container = styled(Box).attrs(({ layout, actionBarHeight }) => ({
  backgroundColor: 'background',
  width: QUEUE_FIXED_WIDTH,
  height: `${
    layout && layout.body && layout.body.height
      ? layout.body.height - CONNECTED_UNIVERSAL_SEARCH_HEIGHT - actionBarHeight
      : layout.body.height
  }px`,
}))`
  z-index: 1;
  @media (max-width: ${BP_LAPTOP}px) {
    width: ${p => (p.isIRP ? QUEUE_FIXED_WIDTH : QUEUE_FULL_WIDTH)};
    height: ${p => !p.isIRP && 'auto'};
  }
`;

export const Tabs = styled.ul`
  display: flex;
  flex-direction: row;
  list-style: none;
  margin: 0;
  padding: 0 6px;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.foreground};
`;

export const Tab = styled.li`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  margin-right: 10px;
  padding: 6px;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  background-color: ${({ active, theme, notifyByAlertType }) =>
    notifyByAlertType === ACTIVE_ASSAILANT
      ? theme.colors.lightDanger
      : notifyByAlertType === TRAIN_INCIDENT_ALERT_TYPE
        ? theme.colors.trainIncidentAlert.iconBg
        : active
          ? theme.colors.background
          : theme.colors.foreground};
  border: ${({ theme }) => `1px solid ${theme.colors.lightLineDivider}`};
  border-bottom-color: ${({ active, theme }) =>
    active ? theme.colors.background : theme.colors.lightLineDivider};
  border-radius: 5px 5px 0 0;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  text-transform: capitalize;
  cursor: pointer;
  transition: background-color 0.3s;
  z-index: 10;
  &:last-child {
    margin-right: 0;
  }
  &:hover {
    ${({ active, theme, notifyByAlertType }) =>
      !active &&
      `background-color: ${
        notifyByAlertType === ACTIVE_ASSAILANT
          ? theme.colors.heavyDanger
          : notifyByAlertType === TRAIN_INCIDENT_ALERT_TYPE
            ? theme.colors.trainIncidentAlert.hoverBg
            : theme.colors.lightLineDivider
      }`};
  }
  @media (max-width: ${BP_LAPTOP}px) {
    width: 366px;
  }
`;

export const IconWrapper = styled(Box).attrs(
  ({ type, notifyByAlertType, theme }) => ({
    flex: '0 0 auto',
    marginRight: '8px',
    color:
      type === AGENCY_CHAT
        ? theme.colors.secondaryText
        : type === ALERTS
          ? notifyByAlertType === ACTIVE_ASSAILANT
            ? 'background'
            : notifyByAlertType === TRAIN_INCIDENT_ALERT_TYPE
              ? theme.colors.trainIncidentAlert.iconColor
              : 'states'
          : 'success',
  }),
)``;

export const TabLabel = styled(Text).attrs(
  ({ theme, type, notifyByAlertType }) => ({
    marginRight: '5px',
    color:
      type === AGENCY_CHAT
        ? theme.colors.secondaryText
        : type === ALERTS
          ? notifyByAlertType === ACTIVE_ASSAILANT
            ? theme.colors.background
            : notifyByAlertType === TRAIN_INCIDENT_ALERT_TYPE
              ? theme.colors.trainIncidentAlert.iconColor
              : theme.colors.states
          : type === EMERGENCY_CALLS
            ? theme.colors.success
            : theme.colors.primaryText,
  }),
)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TitleWrapper = styled(Box).attrs({
  justify: 'center',
  width: '100%',
  height: `${TITLE_WRAPPER_HEIGHT}px`,
  padding: '16px 20px',
})`
  flex: 0 0 auto;
  border-top: ${({ theme }) => `1px solid ${theme.colors.lightLineDivider}`};
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.lightLineDivider}`};
  z-index: 5;
  @media (max-width: ${BP_LAPTOP}px) {
    width: 100%;
  }
`;
export const QueueBorderTabs = styled(Box).attrs({
  mt: '-1px',
})`
  border-top: ${({ theme }) => `1px solid ${theme.colors.lightLineDivider}`};
`;

export const Title = styled(Text).attrs(({ type }) => ({
  size: 'normal',
  fontWeight: 'bold',
  color:
    type === ALERTS
      ? 'states'
      : type === EMERGENCY_CALLS
        ? 'success'
        : 'primaryText',
}))``;

export const Subtitle = styled(Text).attrs({
  color: 'primaryText',
  size: 'small',
})``;

export const Content = styled.div`
  display: ${({ active }) => (active ? 'flex' : 'none')};
  height: ${({ hasSingleTab }) =>
    `calc(100% - ${hasSingleTab ? TITLE_WRAPPER_HEIGHT : TABS_HEIGHT}px - ${
      ALL_EVENTS_CONTAINER_HEIGHT_EXTENDED
    }px)`};
  flex: 0 0 auto;
  flex-direction: column;
  overflow: hidden;
  ${({ theme }) => `border-right: 1px solid ${theme.colors.lightLineDivider}`};
  @media (max-width: ${BP_LAPTOP}px) {
    height: 'auto';
  }
`;
